/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsroomguestsperiod3Inputs */

const en_statsroomguestsperiod3 = /** @type {(inputs: Statsroomguestsperiod3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period`)
};

const de_statsroomguestsperiod3 = /** @type {(inputs: Statsroomguestsperiod3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

/**
* | output |
* | --- |
* | "Period" |
*
* @param {Statsroomguestsperiod3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsroomguestsperiod3 = /** @type {((inputs?: Statsroomguestsperiod3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsroomguestsperiod3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsroomguestsperiod3(inputs)
	return de_statsroomguestsperiod3(inputs)
});
export { statsroomguestsperiod3 as "statsRoomGuestsPeriod" }